<template>
    <rkm-area title="Escala de coma de glasgow">
        <template v-if="!readonly" slot="trailing">
            <rkm-button
                @click="$refs.Modal.open()"
                color="primary"
                small
            >
                <rkm-icon icon="plus" />
            </rkm-button>
        </template>

        <List :data="data" />

        <Modal
            :data="data"
            ref="Modal"
        />
    </rkm-area>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'

export default {
    components: { List, Modal },
    props: {
        data: { type: Object, required: true },
        readonly: { type: Boolean, default: false },
    },
}
</script>